import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import QuickAddContent from './QuickAddContent';
import { Button } from '../../components';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { openModal } from '../../components/modal/actions';
import { sendEventToGA, GA_EVENT_USER_SHOPPING } from '../../analytics/constants';

export const QuickAdd = ({ openModal }) => {
  const launchModal = () => {
    openModal({
      type: 'custom',
      element: <QuickAddContent />
    });

    sendEventToGA(GA_EVENT_USER_SHOPPING, {
      userShopping: 'Quick-Add'
    });
  };

  return (
    <Button secondary onClick={launchModal} data-desc='quickAdd__button_openModal'>
      <TranslatedCopy id='gridwall.quickadd.button' />
    </Button>
  );
};

QuickAdd.propTypes = {
  openModal: PropTypes.func.isRequired
};

const connector = connect(null, {
  openModal
});

export default connector(QuickAdd);
